/**
 * Who took an alert step, in words a command centre reads: the system, or a user named by role (Command Supervisor,
 * Crowd Analyst, System Administrator). Never an identifier. The labelled demo actor acts as the Command Supervisor.
 */
export interface AlertActorUser {
  id?: string | null;
  displayName?: string | null;
  role?: string | null;
}

const ROLE_LABELS: Record<string, string> = {
  command_supervisor: 'Command Supervisor',
  crowd_analyst: 'Crowd Analyst',
  system_admin: 'System Administrator',
};

export function alertActorLabel(actorId: string | null | undefined, currentUser?: AlertActorUser | null): string {
  const id = (actorId ?? '').trim();
  if (!id || id === 'system') return 'System';
  if (id === 'demo-duty-team') return ROLE_LABELS.command_supervisor;
  if (currentUser?.id && id === currentUser.id) {
    const role = ROLE_LABELS[String(currentUser.role ?? '')] ?? 'Command Supervisor';
    return currentUser.displayName ? `${currentUser.displayName} · ${role}` : role;
  }
  // Another signed-in user: only their role is known to this screen, and an alert is worked by the supervisor or an
  // analyst, so say so plainly rather than invent a team.
  return 'Another user';
}
